module.exports = __webpack_public_path__ + "img/icon-newsletter.445af138.svg";